import { createContext, useContext, useState } from "react";

export const PHONE_DISPLAY = "+49 151 63373737";
export const PHONE_TEL = "tel:+4915163373737";
export const WA_LINK = "https://wa.me/4915163373737";
export const EMAIL = "rsvirk13@gmail.com";
export const ADDRESS = "INA-Ring 12, 91074 Herzogenaurach";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const en = {
  nav: {
    home: "Home",
    about: "About Us",
    services: "Services",
    fleet: "Fleet",
    pricing: "Pricing",
    contact: "Contact",
    book: "Book Taxi",
  },
  hero: {
    eyebrow: "24/7 PREMIUM TAXI SERVICE",
    titleA: "Taxi",
    titleB: "Services",
    titleC: "in Herzogenaurach",
    sub: "Airport Transfers • Train Station Transfers • Local Taxi • Long Distance Travel",
    bookNow: "Book Taxi Now",
    waNow: "WhatsApp Now",
    stat1: "Viele Jahre",
    stat1label: "ERFAHRUNG",
    stat2: "24/7",
    stat2label: "ALWAYS AVAILABLE",
    scroll: "SCROLL",
  },
  about: {
    eyebrow: "01 ABOUT US",
    title: "Viele Jahre Erfahrung",
    p1: "We are a professional taxi company – viele Jahre Erfahrung. We provide taxi services in Herzogenaurach and Erlangen, and we also offer airport and train station transfers throughout Germany.",
    p2: "Our taxis are modern, clean and comfortable. Customer safety and satisfaction are our highest priorities – we especially care for women, children and senior citizens.",
    p3: "Fixed prices and 24/7 service available. Payment by card, cash and online possible.",
    checks: [
      "Modern, clean, comfortable vehicles",
      "Safe rides for women, children & seniors",
      "Fixed prices — no hidden fees",
      "Card, cash & online payments",
    ],
    stripValue: "Viele Jahre",
    stripLabel: "ERFAHRUNG",
    imgCta: "Book Taxi",
  },
  services: {
    eyebrow: "02 SERVICES",
    title: "Everything you need on the road",
    items: [
      { t: "Passenger Transportation", d: "Reliable rides, day and night." },
      { t: "Group Trips (up to 7 Persons)", d: "Spacious vehicles for families and groups." },
      { t: "Airport Transfers", d: "Punctual transfers to all German airports." },
      { t: "Hotel Transfers", d: "Direct rides to and from your hotel." },
      { t: "Trade Fair Transfers", d: "On-time service for business travellers." },
      { t: "Courier Services", d: "Fast and reliable delivery on demand." },
    ],
  },
  why: {
    eyebrow: "03 WHY CHOOSE US",
    title: "Reasons to ride with us",
    items: [
      { t: "Individual Billing", d: "Transparent single-ride invoicing." },
      { t: "Card Payments", d: "EC, Visa, Mastercard and more accepted." },
      { t: "German, Turkish & English", d: "Communication in your preferred language." },
      { t: "Fixed Price Service", d: "Know your fare before you ride." },
      { t: "24/7 Service", d: "Day, night, weekends and holidays." },
      { t: "Airport Specialists", d: "Reliable transfers across all of Germany." },
      { t: "Safe & Reliable", d: "Licensed, insured and always punctual." },
      { t: "Professional Drivers", d: "Friendly chauffeurs with local knowledge." },
    ],
  },
  fleet: {
    eyebrow: "04 OUR FLEET",
    title: "Modern vehicles, ready to go",
    cap1: "1–4 Passengers",
    cap2: "1–5 Passengers",
    cap3: "1–7 Passengers",
    items: [
      { t: "Standard Taxi", d: "Comfortable sedan for daily rides." },
      { t: "Family Vehicle", d: "Extra space for families and luggage." },
      { t: "Minivan", d: "Ideal for groups and long journeys." },
    ],
  },
  pricing: {
    eyebrow: "05 PRICING",
    title: "Honest fares. No surprises.",
    tariff: "TAXI TARIFF",
    tariffLink: "Taxi Tariff Ordinance 2023 (PDF) – Erlangen-Höchstadt",
    tariffNote: "For the prices according to kilometres, click on this link.",
    distTitle: "OUR PROMISE",
    dist: [
      "Fixed price agreed before every ride",
      "Official Erlangen-Höchstadt taxi tariff",
      "No hidden fees, no surprises",
      "Available 24/7 – day and night",
    ],
    distNote: "Card, cash & online payment",
  },
  payments: {
    eyebrow: "ACCEPTED PAYMENTS",
    title: "Pay the way you prefer",
    methods: [
      ["CASH", "Bargeld"],
      ["girocard", "EC-Karte"],
      ["VISA", ""],
      ["Mastercard", ""],
      ["AMEX", ""],
    ],
    note: "Fixed price and 24/7 service available. Payment by card, cash and online possible.",
  },
  book: {
    eyebrow: "07 BOOK TAXI",
    title: "Reserve your ride in seconds",
    fName: "FULL NAME",
    fPhone: "PHONE NUMBER",
    fPickup: "PICKUP LOCATION",
    fDest: "DESTINATION",
    fDate: "DATE",
    fTime: "TIME",
    fPass: "PASSENGERS",
    fDesc: "DESCRIPTION",
    phName: "Your name",
    phPhone: "+49 ...",
    phPickup: "e.g. INA-Ring 12, Herzogenaurach",
    phDest: "e.g. Nürnberg Airport (NUE)",
    phDesc: "Child seat, luggage, flight number...",
    sending: "Sending...",
    successTitle: "Booking received",
    successText: "Thank you! We'll call you shortly to confirm your ride.",
    another: "Book another ride",
    error: "Booking could not be sent. Please call or WhatsApp us.",
    submit: "Book Taxi",
    wa: "WhatsApp",
  },
  contact: {
    eyebrow: "08 CONTACT",
    title: "Reach us anytime, 24/7",
    addressLabel: "ADDRESS",
    phoneLabel: "PHONE",
    emailLabel: "EMAIL",
    waLabel: "WHATSAPP",
  },
  footer: {
    tagline:
      "Premium taxi service in Herzogenaurach & Erlangen. Available 24/7 for airport transfers, business trips and everyday rides.",
    services: "SERVICES",
    contact: "CONTACT",
    legal: "LEGAL",
    impressum: "Impressum",
    datenschutz: "Datenschutzerklärung",
    rights: "© 2026 Singh Taxi. All rights reserved.",
    cities: "Herzogenaurach • Erlangen • Germany",
  },
};

const de = {
  nav: {
    home: "Start",
    about: "Über Uns",
    services: "Leistungen",
    fleet: "Fuhrpark",
    pricing: "Preise",
    contact: "Kontakt",
    book: "Taxi Buchen",
  },
  hero: {
    eyebrow: "24/7 PREMIUM TAXISERVICE",
    titleA: "Taxi",
    titleB: "Services",
    titleC: "in Herzogenaurach",
    sub: "Flughafentransfers • Bahnhofstransfers • Stadt-Taxi • Langstreckenfahrten",
    bookNow: "Jetzt Taxi Buchen",
    waNow: "Jetzt WhatsApp",
    stat1: "Viele Jahre",
    stat1label: "ERFAHRUNG",
    stat2: "24/7",
    stat2label: "IMMER VERFÜGBAR",
    scroll: "SCROLLEN",
  },
  about: {
    eyebrow: "01 ÜBER UNS",
    title: "Viele Jahre Erfahrung",
    p1: "Wir sind ein professionelles Taxiunternehmen mit vielen Jahren Erfahrung. Wir bieten Taxidienste in Herzogenaurach und Erlangen an und führen außerdem Flughafen- und Bahnhofstransfers in ganz Deutschland durch.",
    p2: "Unsere Taxis sind modern, sauber und komfortabel. Sicherheit und Zufriedenheit unserer Kunden stehen an oberster Stelle – besonders kümmern wir uns um Frauen, Kinder und Senioren.",
    p3: "Festpreise und 24/7-Service verfügbar. Zahlung per Karte, bar und online möglich.",
    checks: [
      "Moderne, saubere, komfortable Fahrzeuge",
      "Sichere Fahrten für Frauen, Kinder & Senioren",
      "Festpreise — keine versteckten Kosten",
      "Karten-, Bar- & Onlinezahlung",
    ],
    stripValue: "Viele Jahre",
    stripLabel: "ERFAHRUNG",
    imgCta: "Taxi Buchen",
  },
  services: {
    eyebrow: "02 LEISTUNGEN",
    title: "Alles, was Sie unterwegs brauchen",
    items: [
      { t: "Personenbeförderung", d: "Zuverlässige Fahrten, Tag und Nacht." },
      { t: "Gruppenfahrten (bis zu 7 Personen)", d: "Geräumige Fahrzeuge für Familien und Gruppen." },
      { t: "Flughafentransfers", d: "Pünktliche Transfers zu allen deutschen Flughäfen." },
      { t: "Hoteltransfers", d: "Direkte Fahrten zu und von Ihrem Hotel." },
      { t: "Messetransfers", d: "Pünktlicher Service für Geschäftreisende." },
      { t: "Kurierdienste", d: "Schnelle und zuverlässige Lieferung auf Anfrage." },
    ],
  },
  why: {
    eyebrow: "03 WARUM WIR",
    title: "Gründe, mit uns zu fahren",
    items: [
      { t: "Einzelabrechnung", d: "Transparente Abrechnung der Einzelfahrt." },
      { t: "Kartenzahlung", d: "EC, Visa, Mastercard und mehr akzeptiert." },
      { t: "Deutsch, Türkisch & Englisch", d: "Kommunikation in Ihrer bevorzugten Sprache." },
      { t: "Festpreis-Service", d: "Wissen Sie Ihren Fahrpreis vor der Fahrt." },
      { t: "24/7-Service", d: "Tag, Nacht, Wochenenden und Feiertage." },
      { t: "Flughafen-Spezialisten", d: "Zuverlässige Transfers in ganz Deutschland." },
      { t: "Sicher & Zuverlässig", d: "Lizenziert, versichert und immer pünktlich." },
      { t: "Professionelle Fahrer", d: "Freundliche Chauffeure mit Ortskenntnis." },
    ],
  },
  fleet: {
    eyebrow: "04 UNSER FUHRPARK",
    title: "Moderne Fahrzeuge, bereit für Sie",
    cap1: "1–4 Passagiere",
    cap2: "1–5 Passagiere",
    cap3: "1–7 Passagiere",
    items: [
      { t: "Standard-Taxi", d: "Komfortable Limousine für tägliche Fahrten." },
      { t: "Familienfahrzeug", d: "Extra Platz für Familien und Gepäck." },
      { t: "Minivan", d: "Ideal für Gruppen und lange Strecken." },
    ],
  },
  pricing: {
    eyebrow: "05 PREISE",
    title: "Ehrliche Preise. Keine Überraschungen.",
    tariff: "TAXI-TARIF",
    tariffLink: "Taxi-Tarif-Ordnung 2023 (PDF) – Erlangen-Höchstadt",
    tariffNote: "Für die Preise je nach Kilometern klicken Sie auf diesen Link.",
    distTitle: "UNSER VERSPRECHEN",
    dist: [
      "Festpreis vor jeder Fahrt vereinbart",
      "Offizieller Taxitarif Erlangen-Höchstadt",
      "Keine versteckten Kosten, keine Überraschungen",
      "24/7 erreichbar – Tag und Nacht",
    ],
    distNote: "Karten-, Bar- & Onlinezahlung",
  },
  payments: {
    eyebrow: "AKZEPTIERTE ZAHLUNGEN",
    title: "Zahlen Sie, wie Sie bevorzugen",
    methods: [
      ["CASH", "Bargeld"],
      ["girocard", "EC-Karte"],
      ["VISA", ""],
      ["Mastercard", ""],
      ["AMEX", ""],
    ],
    note: "Festpreis und 24/7-Service verfügbar. Zahlung per Karte, bar und online möglich.",
  },
  book: {
    eyebrow: "07 TAXI BUCHEN",
    title: "Reservieren Sie Ihre Fahrt in Sekunden",
    fName: "VOLLSTÄNDIGER NAME",
    fPhone: "TELEFONNUMMER",
    fPickup: "ABHOLORT",
    fDest: "ZIEL",
    fDate: "DATUM",
    fTime: "UHRZEIT",
    fPass: "PASSAGIERE",
    fDesc: "BESCHREIBUNG",
    phName: "Ihr Name",
    phPhone: "+49 ...",
    phPickup: "z. B. INA-Ring 12, Herzogenaurach",
    phDest: "z. B. Flughafen Nürnberg (NUE)",
    phDesc: "Kindersitz, Gepäck, Flugnummer...",
    sending: "Wird gesendet...",
    successTitle: "Buchung erhalten",
    successText: "Vielen Dank! Wir rufen Sie in Kürze an, um Ihre Fahrt zu bestätigen.",
    another: "Weitere Fahrt buchen",
    error: "Buchung konnte nicht gesendet werden. Bitte rufen Sie uns an oder schreiben Sie per WhatsApp.",
    submit: "Taxi Buchen",
    wa: "WhatsApp",
  },
  contact: {
    eyebrow: "08 KONTAKT",
    title: "Erreichen Sie uns jederzeit, 24/7",
    addressLabel: "ADRESSE",
    phoneLabel: "TELEFON",
    emailLabel: "E-MAIL",
    waLabel: "WHATSAPP",
  },
  footer: {
    tagline:
      "Premium-Taxiservice in Herzogenaurach & Erlangen. Rund um die Uhr verfügbar für Flughafentransfers, Geschäftsfahrten und alltägliche Fahrten.",
    services: "LEISTUNGEN",
    contact: "KONTAKT",
    legal: "RECHTLICHES",
    impressum: "Impressum",
    datenschutz: "Datenschutzerklärung",
    rights: "© 2026 Singh Taxi. Alle Rechte vorbehalten.",
    cities: "Herzogenaurach • Erlangen • Deutschland",
  },
};

const dict = { en, de };

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      return localStorage.getItem("singh-taxi-lang") === "en" ? "en" : "de";
    } catch (e) {
      return "de";
    }
  });

  const setLang = (l) => {
    try {
      localStorage.setItem("singh-taxi-lang", l);
    } catch (e) {
      /* ignore */
    }
    setLangState(l);
  };

  const t = dict[lang] || en;
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
